<template>
  <v-btn color="primary lighten-2"
         :disabled="requestState === 'Loading'"
         @click="handleClickExport">
    Export
    <v-progress-circular v-if="requestState === 'Loading'" indeterminate/>
  </v-btn>
</template>

<script>
    import {mapState} from "vuex";
    import FileSaver from 'file-saver'
    import {caseServiceLogService} from "../../application";
    import {RequestState} from '../../requestState'
    import {notificationService} from '../../application'

    export default {
        name: 'analytics-data-as-csv',
        props: {},
        data() {
            return {
                requestState: RequestState.NotPerformed
            }
        },
        computed: {
            ...mapState({
                filter: state => state.analytics.filter
            })
        },
        methods: {
            handleClickExport() {
                if (this.requestState === RequestState.Loading) {
                    return
                }

                this.requestState = RequestState.Loading;
                caseServiceLogService
                    .getFilteredServicesAsCsv({
                        ...this.filter,
                        pagination: {
                            offset: 0,
                            limit: 10000000000
                        }
                    })
                    .then(data => {
                        const csv = '\ufeff' + data.data;
                        let blob = new Blob([csv], {type: 'text/csv;charset=UTF-8;'});
                        FileSaver.saveAs(blob, `services.csv`);
                        this.requestState = RequestState.Success;
                    })
                    .catch(e => {
                        notificationService.error('Can\'t perform operation');
                        this.requestState = RequestState.Failed;
                    })
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/analytics/AnalyticsDataAsCsv.vue